import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';

import LoginPage from './auth/login-page';
import Signup from './auth/signup';
import VerifyEmail from './pages/signup/verify_email'
import VerifyEmailSHandler from './pages/signup/email_verification_handler';

import Home from './pages/home';
import Privacy from './pages/privacy';
import Terms from './pages/terms';
import ChatX from './pages/chat';
import Error from './pages/error';
import PostThread from './pages/thread/create_thread'
import MyThreads from './pages/thread/my_thread'
import PopularThreadsByUserCount from './pages/thread/thread_by_user_count'
import PopularThreadsByMessageCount from './pages/thread/thread_by_message_count'
import PopularThreadsToday from './pages/thread/popular_thread_today'
import PopularThreadThisWeek from './pages/thread/popular_thread_this_week'
import LatestThreads from './pages/thread/latest_thread'
import AccountSetting from './pages/user/account_setting'
import PasswordResetHandler from './pages/password_reset/password_reset_handler'
import AuthLinkClickHandler from './auth/auth_link_click_handler'
import ForgotPassword from './pages/password_reset/forgot_password'
import UserProfile from './pages/user/user_profile';

import { Route, Switch } from 'react-router-dom';

import './App.css';
import { SingleCol, TwoCol, BoxLayout } from './layout';

class App extends Component {

  componentDidMount() {
    const query = new URLSearchParams(window.location.search);
    const setMagicSpell = query.get('setMagicSpell');
		
		if (setMagicSpell === 'true') {
			Cookies.set('magic-spell', 'opensesame');
		} else if (setMagicSpell === 'false') {
			Cookies.remove('magic-spell');
		}
  }

  render() {
    if (Cookies.get('magic-spell') !== 'opensesame') {
      return <Route exact path="/" render={() => (window.location = "https://launch.bupples.com")} />;
    }

    const { messages, reactions, user } = this.props;

    const style = {};
    if (this.props.general && this.props.general.theme_image) {
      style.backgroundImage = 'url(' + this.props.general.theme_image + ')'
    }
    return (
      <Switch>
        <Route path="/" exact>
          <SingleCol page={<Home />} />
        </Route>
        <Route path="/login" exact>
          <BoxLayout>
            <LoginPage />
          </BoxLayout>
        </Route>
        <Route path="/sign-up" exact>
          <BoxLayout>
            <Signup />
          </BoxLayout>
        </Route>
        <Route
          path='/thread/:id'
          render={(props) => (
            <ChatX />
          )}
        />
        <Route path="/terms" exact>
          <SingleCol page={<Terms />} />
        </Route>
        <Route path="/privacy" exact>
          <SingleCol page={<Privacy />} />
        </Route>
        <Route exact path="/create-thread">
          <SingleCol page={<PostThread />} />
        </Route>
        <Route exact path="/edit-thread/:id">
          <SingleCol page={<PostThread />} />
        </Route>
        <Route exact path="/verify-email">
          <SingleCol page={<VerifyEmail />} />
        </Route>
        <Route exact path="/verify-user-email">
          <SingleCol page={<VerifyEmailSHandler />} />
        </Route>
        <Route exact path="/forgot-password">
          <BoxLayout>
            <ForgotPassword />
          </BoxLayout>
        </Route>
        <Route exact path="/auth-email">
          <SingleCol page={<AuthLinkClickHandler />} />
        </Route>
        <Route exact path="/reset-password">
          <SingleCol page={<PasswordResetHandler />} />
        </Route>
        <Route exact path="/my-threads">
          <SingleCol page={<MyThreads />} />
        </Route>
        <Route exact path="/settings">
          <SingleCol page={<AccountSetting />} />
        </Route>
        <Route exact path="/thread-by-user-count">
          <SingleCol page={<PopularThreadsByUserCount />} />
        </Route>
        <Route exact path="/thread-by-message-count">
          <SingleCol page={<PopularThreadsByMessageCount />} />
        </Route>
        <Route exact path="/popular-thread-today">
          <SingleCol page={<PopularThreadsToday />} />
        </Route>
        <Route exact path="/popular-thread-this-week">
          <SingleCol page={<PopularThreadThisWeek />} />
        </Route>
        <Route exact path="/latest-thread">
          <SingleCol page={<LatestThreads />} />
        </Route>
        <Route exact path="/user-profile/:handle_id">
          <SingleCol page={<UserProfile />} />
        </Route>
        <Route>
          <Error></Error>
        </Route>
      </Switch>
    );
  }
}

App.propTypes = {
  messages: PropTypes.array,
  reactions: PropTypes.object,
  general: PropTypes.object,
  user: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    messages: state.messages,
    reactions: state.reactions,
    general: state.general,
    user: state.user
  };
};

const mapDispatchToProps = dispatch => {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
